import React from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/Home/Navbar/Navbar";
import Footer from "../components/Home/Footer/Footer";

const NotFoundpage = () => (
  <>
    <Navbar />
    <main style={{ minHeight: "55vh", padding: "10rem 1.5rem 5rem", textAlign: "center" }}>
      <h1>Page Not Found</h1>
      <p>The page may have moved or no longer exists.</p>
      <p><Link to="/">Return home</Link> or <Link to="/contact">contact Primed Landscaping</Link>.</p>
    </main>
    <Footer />
  </>
);

export default NotFoundpage;
